import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import StudentsPage from './pages/StudentsPage';
import InstitutionsPage from './pages/InstitutionsPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/students" element={<StudentsPage />} />
          <Route path="/institutions" element={<InstitutionsPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
